import { call } from 'redux-saga/effects';
import { websocketFetch } from 'common/websocket-redux';

export const getUserVaccinationWorkflow = ({ vaccineType, userId }) =>
  call(websocketFetch, 'get_user_vaccination_workflow', {
    vaccine_type: vaccineType,
    user_id: userId,
  });
